import React from "react"
import Content from "../../../anwendungskonfigurator/components/Content"

const PrintContainer = ({container}) => {
    return (
        <div className="print-only">
            {container.children?.map((child) => (
                <Content child={child}/>
            ))}
        </div>
    )
}

export default PrintContainer